// Distinguishes which surface drove a MatterInviteSent / MatterInviteSendFailed — Manage Members
// entry points (header CTA, avatar stack, collaboration banner, matters-table overflow) or inline
// Add Team Members during matter creation — so create-time sharing is not conflated with modal invites.
export enum MatterCollaborationEntrySource {
  Header = 'header',
  // Avatar stack is a separate "view members" affordance in the same chrome as Header — do not
  // collapse it into Header or invite attribution will inflate the Add Members CTA funnel.
  Avatar = 'avatar',
  CollaborationBanner = 'collaboration_banner',
  OverflowMenu = 'overflow_menu',
  // Create Matter dialog — Add Team Members typeahead (FE-501 / DAT-23). Not a Manage Members modal.
  MatterCreation = 'matter_creation',
  // Resolver fallback only — every current call site passes an explicit source.
  Unknown = 'unknown',
}
